import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-pg-programs',
  templateUrl: './pg-programs.component.html',
  styleUrls: ['./pg-programs.component.scss']
})
export class PgProgramsComponent implements OnInit {

 constructor(private crudService: CrudService) { }

  baseUrl = this.crudService.baseUrl;
  baseUrl1 = this.crudService.baseUrl1;

  ngOnInit(): void {
  }

}
